
import request from '../utils/request'


// 官网首页资质信息展示
function getHomeQua(data){
    return request({
        url : '/qualification/getHomeQua',
        method : 'post',
        data,
    });
}






export default {
    getHomeQua
}